"use client";
import { jsx as _jsx } from "react/jsx-runtime";
export function CookieFloatingButton({ onClick, position = "bottom-right", }) {
    const positionClasses = {
        "bottom-right": "bottom-5 right-5",
        "bottom-left": "bottom-5 left-5",
        "bottom-center": "bottom-5 left-1/2 transform -translate-x-1/2",
    };
    return (_jsx("button", { onClick: onClick, className: `fixed ${positionClasses[position]} z-50 w-12 h-12 bg-white border border-gray-200 rounded-full shadow-lg hover:shadow-xl transition-shadow duration-200 flex items-center justify-center hover:cursor-pointer`, title: "Cookie Preferences", "aria-label": "Open cookie preferences", "data-testid": "cookie-floating-button", id: "cookie-floating-button", children: _jsx("img", { src: "https://cdn.inito.com/inito_website/cookie/cookie-icon.svg" }) }));
}
